import React, { useState, useEffect } from 'react';
import StrategyService from '../../services/StrategyService';
import ManageStrategiesModal from '../Strategy/ManageStrategiesModal';

interface StrategiesPageProps {
  isOpen: boolean;
  onClose: () => void;
}

const StrategiesPage: React.FC<StrategiesPageProps> = ({ isOpen, onClose }) => {
  const [strategies, setStrategies] = useState<{ [key: string]: string }>({});
  const [notification, setNotification] = useState<{ message: string; type: 'success' | 'error' } | null>(null);

  // Load saved strategies on component mount
  useEffect(() => {
    if (isOpen) {
      loadStrategies();
    }
  }, [isOpen]);

  // Load saved strategies
  const loadStrategies = () => {
    const savedStrategies = StrategyService.getSavedStrategies();
    setStrategies(savedStrategies);
  };

  // Handle loading a strategy
  const handleLoadStrategy = (stateData: string) => {
    const success = StrategyService.loadStrategy(stateData);
    
    if (success) {
      showNotification('Strategy loaded successfully!', 'success');
      // Close the modal after a short delay
      setTimeout(() => {
        onClose();
        window.location.reload(); // Reload to ensure all components update
      }, 1000);
    } else {
      showNotification('Failed to load strategy', 'error');
    }
  };

  // Handle deleting a strategy
  const handleDeleteStrategy = (name: string) => {
    const success = StrategyService.deleteStrategy(name);
    
    if (success) {
      showNotification(`Strategy "${name}" deleted`, 'success');
      loadStrategies(); // Refresh the list
    } else {
      showNotification('Failed to delete strategy', 'error');
    }
  };

  // Show notification
  const showNotification = (message: string, type: 'success' | 'error') => {
    setNotification({ message, type });
    
    // Clear notification after 3 seconds
    setTimeout(() => {
      setNotification(null);
    }, 3000);
  };

  return (
    <>
      <ManageStrategiesModal
        isOpen={isOpen}
        onClose={onClose}
        strategies={strategies}
        onLoadStrategy={handleLoadStrategy}
        onDeleteStrategy={handleDeleteStrategy}
      />
      
      {/* Notification */}
      {notification && (
        <div 
          className={`fixed top-4 right-4 px-4 py-2 rounded shadow-lg z-50 ${
            notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'
          } text-white`}
        >
          {notification.message}
        </div>
      )}
    </>
  );
};

export default StrategiesPage;